var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeSearchBarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.23 35.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f5eb;}.cls-2{fill:none;stroke:#f3f5eb;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.41,
    y: 18.57,
    width: 5.09,
    height: 17.92,
    rx: 1.37,
    transform: "translate(18.35 1.52) rotate(37.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.27,
    cy: 12.97,
    r: 10.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeSearchBarWhite);
export default __webpack_public_path__ + "static/media/icone_search_bar_white.50d2a99b0bc940020c53d2b0a2686def.svg";
export { ForwardRef as ReactComponent };